import React from "react";
import PdfViewer from "../../PdfViewer";

const PythonTema2 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema2_Primeros_Conceptos.pdf`;
  /*const pdfUrl = "/pdf/Tema2_Primeros_Conceptos.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Tema 2: Primeros Conceptos</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PythonTema2;
